import { CoreAPI, createAPIMethod, createCommonOrderMethods } from '@hero/sdk-core';
import {
  CarrierOrdersAPI,
  PublishedOrdersAPI,
  OrderBestMatchCarrierVehiclesAPI,
  OrderExportCarrierAPI,
  API,
} from '@hero/api';

export function createOrdersAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonOrderMethods(coreAPI),

    /**
     * Get carrier orders
     *
     * API: {@link CarrierOrdersAPI}
     */
    getCarrierOrders: createAPIMethod<CarrierOrdersAPI>(coreAPI, 'order.carrierOrders'),

    /**
     * Get published orders (jobs)
     *
     * API: {@link PublishedOrdersAPI}
     */
    getPublishedOrders: createAPIMethod<PublishedOrdersAPI>(coreAPI, 'order.publishedOrders'),

    /**
     * Get best match vehicles for order
     *
     * API: {@link OrderBestMatchCarrierVehiclesAPI}
     */
    getBestMatchVehicles: createAPIMethod<OrderBestMatchCarrierVehiclesAPI>(
      coreAPI,
      'order.carrierBestMatchVehicles',
    ),

    /**
     * Get active driver order
     */
    getActiveDriverOrder: createAPIMethod<API<any, any>>(coreAPI, 'order.activeDriverOrder'),

    /**
     * Export orders to Excel
     *
     * API: {@link OrderExportCarrierAPI}
     */
    exportOrders: createAPIMethod<OrderExportCarrierAPI>(coreAPI, 'order.carrierExport'),
  };
}
